import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CommonNav from "../main/CommonNav2";
import LogiWorkLandingCarousel from "./component/LogiWorkLandingCarousel";
import LogiWorkLandingSolution from "./component/LogiWorkLandingSolution";
import LogiWorkLandingConnect from "./component/LogiWorkLandingConnect";
import LogiWorkInquiryModal from "./component/LogiWorkInquiryModal";
import Footer from "../main/Footer";
import BuddibleSocket, { MsgIDList } from "../lib/BuddibleSocket";

const socket = new BuddibleSocket();
const _mClassName = "LogiWorkLanding";

export default function LogiWorkLanding() {
  const [loginInfo, setLoginInfo] = useState(null);
  const [isInquiryModalOpen, setIsInquiryModalOpen] = useState(false);
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(i18n.language, () => {});

    let userData = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userData) {
      setLoginInfo(userData);
    }

    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        if (!n) return;
        if (!n["returnData"].length) return;
        setLoginInfo(n["returnData"][0]);
      }
    );

    return () => {
      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );
    };
  }, []);

  return (
    <>
      <CommonNav />
      <main id="logitalk_landing">
        <LogiWorkLandingCarousel
          loginInfo={loginInfo}
          setIsInquiryModalOpen={setIsInquiryModalOpen}
        />
        <LogiWorkLandingSolution />
        <LogiWorkLandingConnect setIsInquiryModalOpen={setIsInquiryModalOpen} />
      </main>
      <Footer />
      {isInquiryModalOpen && (
        <LogiWorkInquiryModal setIsInquiryModalOpen={setIsInquiryModalOpen} />
      )}
    </>
  );
}
